import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AboutBanner from "../AboutBanner/AboutBanner";
import { trackEvent, trackPageView } from "../../utils/tracking";

function Custodian() {
  const [pathname, setPathName] = useState("");

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/Custodian",
      "jmf_about-us_custodian"
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "Custodian Page Loaded",
      label: "jmf_about-us_custodian",
      // value: 1,
    });
  }, []);

  useEffect(() => {
    const pathname = window.location.pathname;
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(CategoryIdUrlid);
  });
  return (
    <>
      <AboutBanner />
      <section className="trustee-sc sponsor-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>
                  <a href="/AboutUs">
                    <i>About Us</i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                {window.location.pathname != "/AboutUs" ? (
                  <li>{pathname}</li>
                ) : (
                  ""
                )}
              </ul>
              <div className="section-header">
                <h2>Custodian</h2>
              </div>
            </Col>
            <Col sm={12}>
              <div className="about-common-left">
                <h6>HDFC Bank Ltd,</h6>
                <h5>Custody Services</h5>
                <p>
                  Empire Plaza 1,4th Floor, Chandan Nagar. L.B.S. Marg,Vikhroli
                  -West, Mumbai 400083, Maharashtra , India.
                </p>

                <p>
                  <b>Ph No:</b> (022)-68565227 <br></br>
                  <b>Fax No:</b>
                  <br></br> 022-68565230/31/32/28<br></br> <b>Email: </b>
                  <a
                    target="_blank"
                    href="mailto:Custody.institutions@hdfcbank.com"
                  >
                    Custody.institutions@hdfcbank.com
                  </a>
                </p>
              </div>
              <div className="about-common-right">
                <p>
                  The Custodian is registered with SEBI under Registration No.
                  IN/CUS/001 dated February 2, 1998. The Trustee and the AMC
                  Board have entered into a Custodian Agreement with the
                  Custodian and the salient features of the said Agreement with
                  respect to its functions and responsibilities are:
                </p>
                <div className="vision-data">
                  <ul>
                    <li>
                      Provide post-trading and custodial services to the Mutual
                      Fund.
                    </li>
                    <li>Ensure benefits due on the holdings are received.</li>
                    <li>
                      Provide detailed management information and other reports
                      as required by the AMC Board.
                    </li>
                    <li>Maintain confidentiality of the transactions.</li>
                    <li>Segregate assets of each Scheme.</li>
                    <li>
                      The Custodian shall not assign, transfer, hypothecate,
                      pledge, lend, use or otherwise dispose any assets or
                      property, except pursuant to instructions from the
                      Trustee/AMC or under the express provisions of the
                      Custodian Agreement.
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Custodian;
